var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.578,
    height: 13.578,
    viewBox: "0 0 13.578 13.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-ico",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1260",
    "data-name": "Trac\\xE9 1260",
    d: "M6.539,0a6.539,6.539,0,1,0,6.539,6.539A6.539,6.539,0,0,0,6.539,0m0,12.614a6.075,6.075,0,1,1,6.075-6.075,6.075,6.075,0,0,1-6.075,6.075",
    fill: "#086d84",
    stroke: "#086d84",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1261",
    "data-name": "Trac\\xE9 1261",
    d: "M49.587,44.391a5.2,5.2,0,1,0,5.2,5.2,5.2,5.2,0,0,0-5.2-5.2m.232,9.924v-.774a.232.232,0,0,0-.464,0v.774a4.739,4.739,0,0,1-4.488-4.488h.774a.232.232,0,1,0,0-.464h-.774a4.739,4.739,0,0,1,4.488-4.488v.774a.232.232,0,0,0,.464,0v-.774a4.739,4.739,0,0,1,4.488,4.488h-.774a.232.232,0,1,0,0,.464h.774a4.739,4.739,0,0,1-4.488,4.488",
    transform: "translate(-43.048 -43.049)",
    fill: "#086d84",
    stroke: "#086d84",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1262",
    "data-name": "Trac\\xE9 1262",
    d: "M207.705,116.706h-1.161v-2.554a.232.232,0,1,0-.464,0v2.786a.232.232,0,0,0,.232.232h1.393a.232.232,0,0,0,0-.464",
    transform: "translate(-199.85 -110.476)",
    fill: "#086d84",
    stroke: "#086d84",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIco);
export default __webpack_public_path__ + "static/media/clock-ico.39a9ac9df6b828f1c164b153a3f822b3.svg";
export { ForwardRef as ReactComponent };